export default "/fcbcac1db17390110677298f9d30eeed9c121039/5ba84b7c5997e2a9223c26a23a6fa17e.svg";